import type { QuestionSet } from '../../types'
import securedCardFaqData from './securedCardFaqData'
import prequalFaqData from './prequalFaqData'
import proofOfIncomeFaqData from './proofOfIncomeFaqData'
import type { AccordionTabProps } from '../Accordion'

export default function getQuestionSet(questionSet: QuestionSet): Array<AccordionTabProps> {
  switch (questionSet) {
    case 'securedCard':
      return securedCardFaqData
    case 'proofOfIncome':
      return proofOfIncomeFaqData
    case 'prequal':
      return prequalFaqData
    default:
      return prequalFaqData
  }
}
